export default "__VITE_ASSET__CEI9_iVj__"